(function () {

const $daa8fba351c2b0d4$var$init = ()=>{
    const checkboxNode = document.querySelector('.wp-header__mobile-menu input[type="checkbox"]');
    const overlayNode = document.querySelector(".wp-header__menu-overlay");
    const menuNode = document.querySelector(".wp-header__mobile-menu .wp-header__navigation");
    const subMenuParentNodes = Array.from(menuNode?.querySelectorAll("li.menu-item-has-children"));
    checkboxNode.addEventListener("change", ()=>{
        if (checkboxNode.checked) {
            document.body.classList.add("lock");
            overlayNode.setAttribute("aria-hidden", false);
        } else document.body.classList.remove("lock");
        subMenuParentNodes.forEach((rootNode)=>rootNode.classList.remove("active"));
    });
    subMenuParentNodes.forEach((rootNode)=>{
        const linkNode = rootNode.querySelector("a, button");
        const subMenuNode = rootNode.querySelector(".sub-menu");
        const backBtn = subMenuNode?.querySelector(".sub-menu__back");
        linkNode.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            rootNode.classList.add("active");
            subMenuNode.setAttribute("aria-hidden", false);
        });
        backBtn.addEventListener("click", ()=>{
            rootNode.classList.remove("active");
        });
    });
    overlayNode.addEventListener("transitionend", ()=>{
        if (!checkboxNode.checked) overlayNode.setAttribute("aria-hidden", true);
    });
    subMenuParentNodes.map((node)=>node.querySelector(".sub-menu")).forEach((node)=>{
        node.addEventListener("transitionend", ()=>{
            if (!node.parentElement.matches(".active")) node.setAttribute("aria-hidden", true);
        });
    });
};
if (document.readyState !== "loading") $daa8fba351c2b0d4$var$init();
else document.addEventListener("DOMContentLoaded", ()=>{
    $daa8fba351c2b0d4$var$init();
});


const $ce14de54666875ea$var$init = ()=>{
    const menuNode = document.querySelector(".wp-header__desktop-menu .wp-header__navigation");
    const subMenuParentNodes = Array.from(menuNode?.querySelectorAll("& > ul > li.menu-item-has-children"));
    subMenuParentNodes.forEach((rootNode, i)=>{
        const linkNode = rootNode.querySelector("a, button");
        const subMenu = rootNode.querySelector(".sub-menu");
        [
            linkNode,
            subMenu
        ].forEach((el)=>el.addEventListener("mouseover", (e)=>{
                rootNode.classList.add("active");
                subMenu?.setAttribute("aria-hidden", false);
            }));
        [
            linkNode,
            subMenu
        ].forEach((el)=>el.addEventListener("mouseleave", ()=>rootNode.classList.remove("active")));
    });
    subMenuParentNodes.map((node)=>node.querySelector(".sub-menu")).forEach((node)=>{
        node.addEventListener("transitionend", ()=>{
            if (!node.parentElement.matches(".active")) node.setAttribute("aria-hidden", true);
        });
    });
};
if (document.readyState !== "loading") $ce14de54666875ea$var$init();
else document.addEventListener("DOMContentLoaded", ()=>{
    $ce14de54666875ea$var$init();
});


const $e5d235b0ecf98875$var$init = ()=>{
    const header = document.querySelector("header.wp-header");
    const currentScrollAmount = ()=>{
        return document.documentElement.scrollTop;
    };
    currentScrollAmount() > 25 ? header.classList.add("shadow") : header.classList.remove("shadow");
    document.addEventListener("scroll", ()=>{
        currentScrollAmount() > 25 ? header.classList.add("shadow") : header.classList.remove("shadow");
    });
};
if (document.readyState !== "loading") $e5d235b0ecf98875$var$init();
else document.addEventListener("DOMContentLoaded", ()=>{
    $e5d235b0ecf98875$var$init();
});


const $7278c83f55729215$var$init = ()=>{
    const forms = Array.from(document.querySelectorAll(".wpcf7-form"));
    const rows = Array.from(document.querySelectorAll(".wpcf7-form .form-row"));
    forms.forEach((form)=>{
        const submitBtn = form.querySelector(".wpcf7-submit");
        const output = form.querySelector(".wpcf7-response-output");
        submitBtn.addEventListener("click", ()=>{
            output.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        });
    });
    rows.forEach((row)=>{
        const label = row.querySelector("label");
        const input = row.querySelector("input:not([type='checkbox'], [type='radio'], [type='submit'])");
        if (!label || !input) return;
        input.addEventListener("focusin", ()=>{
            label.classList.add("contract");
        });
        input.addEventListener("blur", ()=>{
            if (input.value.trim() === "") label.classList.remove("contract");
        });
    });
};
if (document.readyState !== "loading") $7278c83f55729215$var$init();
else document.addEventListener("DOMContentLoaded", ()=>{
    $7278c83f55729215$var$init();
});


const $5b9d864465e846a2$export$418f29bcefbde6a9 = (text, contentLength = 22)=>{
    const numWords = text.split(/\s+/).length;
    text.replace(/\[.*?\]/g, "");
    text.replace("]]>", "]]&gt;", text);
    text.replace("@<(script|style)[^>]*?>.*?</\\1>@si", "", text);
    text.trim();
    if (numWords > contentLength) text = text.split(/\s+/).slice(0, contentLength).join(" ");
    return `${text}...`;
};


const $81368b0033b89f28$var$endpoint = "/wp-json/wp/v2/dental-advice";
const $81368b0033b89f28$var$perPage = 6;
const $81368b0033b89f28$var$fetchPosts = (initialLoad = true, searchTerm, page = 0, rootNode, gridNode, templateNode, noResultTemplateNode, paginationNode)=>{
    rootNode.classList.add("is-loading");
    if (initialLoad === false) $81368b0033b89f28$var$smoothScroll();
    fetch(`${$81368b0033b89f28$var$endpoint}?search=${searchTerm}${page > 0 ? `&page=${page}` : ""}&per_page=${$81368b0033b89f28$var$perPage}`).then(async (response)=>{
        const data = await response.json();
        const noResultsClone = noResultTemplateNode.content.cloneNode(true);
        if (data && data.length > 0) {
            const totalPages = response.headers.get("x-wp-totalpages");
            rootNode.innerHTML = "";
            rootNode.appendChild(gridNode);
            rootNode.appendChild(paginationNode);
            gridNode.innerHTML = "";
            data.forEach((item)=>{
                const post = $81368b0033b89f28$var$constructPostFromTemplate(templateNode, item);
                gridNode.appendChild(post);
            });
            $81368b0033b89f28$var$constructPagination(totalPages, page === 0 ? page + 1 : page, searchTerm, rootNode, gridNode, templateNode, noResultTemplateNode, paginationNode);
        } else {
            const searchTermNode = noResultsClone.querySelector("p > span");
            searchTermNode.innerHTML = `${searchTerm}`;
            rootNode.innerHTML = "";
            rootNode.appendChild(noResultsClone);
        }
    }).catch((error)=>{
        console.log(error);
        const noResultsClone = noResultTemplateNode.content.cloneNode(true);
        const searchTermNode = noResultsClone.querySelector("p > span");
        searchTermNode.innerHTML = `${searchTerm}`;
        rootNode.innerHTML = "";
        rootNode.appendChild(noResultsClone);
    }).finally(()=>{
        rootNode.classList.remove("is-loading");
    });
};
const $81368b0033b89f28$var$constructPostFromTemplate = (template, data)=>{
    const cloneNode = template.content.cloneNode(true);
    const linkNode = cloneNode.querySelector(".wp-listing__link");
    const headingNode = cloneNode.querySelector(".wp-listing__heading > h3");
    const contentNode = cloneNode.querySelector(".wp-listing__content > div");
    const { link: link, title: title, excerpt: excerpt, content: content } = data;
    const extractedContent = new DOMParser().parseFromString(content.rendered, "text/html")?.querySelector(".wp-block-sed-content .wp-part-content")?.innerHTML;
    linkNode.setAttribute("href", link);
    headingNode.innerHTML = title.rendered;
    contentNode.innerHTML = excerpt.rendered ? `<p>${excerpt.rendered}</p>` : extractedContent ? (0, $5b9d864465e846a2$export$418f29bcefbde6a9)(extractedContent) : "";
    contentNode.innerHTML == "" ? contentNode.style.display = "none" : contentNode.style.display = "block";
    return cloneNode;
};
const $81368b0033b89f28$var$constructPagination = (totalPages = null, currentPage, searchTerm, rootNode, gridNode, templateNode, noResultTemplateNode, paginationNode)=>{
    paginationNode.innerHTML = "";
    if (!totalPages || !paginationNode || totalPages <= 1) return;
    for(let i = 0; i < totalPages; i++){
        const page = i + 1;
        const li = document.createElement("li");
        const button = document.createElement("button");
        button.textContent = page;
        if (page === currentPage) button.classList.add("is-current-page");
        li.appendChild(button);
        button.addEventListener("click", ()=>{
            $81368b0033b89f28$var$fetchPosts(false, searchTerm, page, rootNode, gridNode, templateNode, noResultTemplateNode, paginationNode);
        });
        paginationNode.appendChild(li);
    }
};
const $81368b0033b89f28$var$smoothScroll = ()=>{
    const mql = window.matchMedia("(max-width: 48.0625em)");
    const node = mql.matches ? document.getElementById("results") : document.getElementById("search");
    const yOffset = -150;
    const y = node.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({
        top: y,
        behavior: "smooth"
    });
};
const $81368b0033b89f28$var$init = ()=>{
    const searchNode = document.querySelector(".wp-part-search");
    const listingNode = document.querySelector(".wp-listing");
    if (searchNode && listingNode) {
        const formNode = search.querySelector("form");
        const inputNode = formNode?.querySelector("input");
        const resultNode = listingNode.querySelector(".wp-listing__results");
        const gridNode = listingNode.querySelector(".wp-listing__grid");
        const postTemplateNode = listingNode.querySelector("template.wp-listng__template");
        const noResultTemplateNode = listingNode.querySelector("template.wp-lisitng__no-results");
        const paginationNode = listingNode.querySelector(".wp-listing__pagination");
        $81368b0033b89f28$var$fetchPosts(true, "", 0, resultNode, gridNode, postTemplateNode, noResultTemplateNode, paginationNode);
        formNode.addEventListener("submit", (e)=>{
            e.preventDefault();
            const searchTerm = inputNode.value.trim();
            $81368b0033b89f28$var$fetchPosts(false, searchTerm, 0, resultNode, gridNode, postTemplateNode, noResultTemplateNode, paginationNode);
        });
    }
};
if (document.readyState !== "loading") $81368b0033b89f28$var$init();
else document.addEventListener("DOMContentLoaded", ()=>{
    $81368b0033b89f28$var$init();
});



})();
//# sourceMappingURL=app.js.map
